import React from 'react';
import { Dialog, DialogTitle, withStyles } from '@material-ui/core';
import * as actions from '../../store/profileActions';
import { connect } from 'react-redux';
import TypicalProblemFormModel from './TypicalProblemForm';
import * as Yup from "yup";
import { snackActions } from '../../../sc-utilities/SnackBar';

const styles = theme => ({
    buttonSafe: {
        '&:hover': {
            color: theme.palette.buttonText.default,
            backgroundColor: theme.palette.secondary.main,
        }
    },
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    }
});

const TypicalProblemModal = props => {
    let { modalState, search, handleFilter, onSaveSettings, activeCustomerID, handleCloseSafe, translations } = props;
    let hotKey = modalState.data && modalState.data.hotKey ? modalState.data.hotKey.split('+')[1] ? modalState.data.hotKey.split('+')[1] : '' : "";
    let initialValues = {
        favorite: modalState.data && modalState.data.favorite ? modalState.data.favorite : false,
        default: modalState.data && modalState.data.default ? modalState.data.default : false,
        hotKey: hotKey
    };

    let formSettings = {
        Validation: {
            favorite: Yup.string().notRequired("Required"),
            default: Yup.string().notRequired("Required"),
            hotKey: Yup.string()
                .trim()
                .matches(/^[0-9]$/, "Is not in correct format").test('hot key not active', 'hot key not active', val => {
                    let includeHotKey = search.hotKey.includes(val) && val !== hotKey
                    if (includeHotKey) {
                        snackActions.snackBarComponent(`${translations['key_is_already_reserved'] || 'This key is already reserved. Please select another key.'}.`, 'warning')
                    }
                    return !includeHotKey

                })
                .notRequired(),
        },
        ButtonSubmit: {
            Title: translations['submit'] || 'Submit',
            Color: 'primary'
        },
    };

    const handleSubmit = async data => {
        let obj = {}
        obj['ActiveCustomerID'] = activeCustomerID;
        obj['type'] = 'TypicalProblems';
        obj['TypicalProblem'] = { ...modalState.data, ...data, hotKey: Number.isInteger(data.hotKey) && data.hotKey !== ' ' ? `ctrl+${data.hotKey}` : '' };
        await onSaveSettings(obj)
        await handleFilter()
        handleCloseSafe()
    }

    return (
        <Dialog
            open={modalState.open}
            onClose={handleCloseSafe}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title">{modalState.data.label}</DialogTitle>
            < TypicalProblemFormModel translations={translations} search={search} modalState={modalState} initialValues={initialValues} formSettings={formSettings} handleSubmit={handleSubmit} handleCloseSafe={handleCloseSafe} />
        </Dialog>
    );
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSaveSettings: params => dispatch(actions.saveSettings(params))
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(TypicalProblemModal));

